export default __webpack_public_path__ + "fonts/varsity_regular.ttf";